module.exports = __webpack_public_path__ + "static/img/commit_succ.edf022d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedback/commit_succ.png
// module id = /gwp
// module chunks = 2